window.app = window.app || {};

app.init = function () {
    app.navigations.init();
    app.subnav.init();
    app.ticker.init();
    app.fednotlink.init();
    app.objectfit.init();
    app.tabpannel.init();
    app.ieflex.init();
    app.swipe.init();
    app.gallery.init();
    app.modal.init();
    app.showhide.init();
    app.calendar.init();
    app.immo.init();
    app.contact.init();
    app.print.init();
    app.helpers.init();
    app.notarissearcher.init();
    app.subscription.init();
    app.tagsclicked.init();
    app.scrollToGlossary.init();
    app.historyReminderOnCalculate.init();
    app.hash.init();

    //javascript from old notaris site
    app.old.init();
};

var searchIsAnimating = false;
app.navigations = {
    init: function () {
        //click on more in navigation
        $(".js-show-subnavigation").on("click", app.navigations.showSubNavigation);
        $(".js-show-subnavigation-mobile").on(
            "click",
            app.navigations.showSubNavigationMobile
        );

        //click on search in showSubNavigation
        $(".js-searchoverlay").on("click", app.navigations.showSearch);
        $(".js-searchoverlay").dblclick(function (e) {
            e.preventDefault();
        });
        $(".js-searchform").on("submit", app.navigations.submitSearch);
        $(".js-searchform button").dblclick(function (e) {
            e.preventDefault();
        });
        $(".js-search").css("minWidth", $(".js-search").outerWidth(true));

        //click on mobile menu
        $(".js-mobile-menu").on("click", app.navigations.mobileMenuToggle);

        //set subnav to display and remove u-hidden for better animation
        $(".js-subnav").hide();
        $(".js-subnav-mobile").hide();
        $(".js-subnav").removeClass("u-hidden");
        $(".js-subnav-mobile").removeClass("u-hidden");

        //sven navigation
        $(".js-sven-navigation").on("click", app.navigations.goToSvenModule);

        //toggle sven address list
        $('.js-home-icon').hover(app.navigations.showAddressList, app.navigations.hideAddressList);
        $('.js-nav-address-list').hover(app.navigations.showAddressList, app.navigations.hideAddressList);

        //toggle sven address list
        $('.js-splash-item').hover(app.navigations.highlightSplashItem, app.navigations.unHighlightSplashItem);
    },
    showSubNavigation: function (evt) {
        evt.preventDefault();
        if ($(".js-subnav").css("display") == "none") {
            $(".js-subnav").slideDown();
            $(".js-show-subnavigation").addClass("rotate");
        } else {
            $(".js-subnav").slideUp();
            $(".js-show-subnavigation").removeClass("rotate");
        }
    },
    showSubNavigationMobile: function (evt) {
        evt.preventDefault();
        if ($(".js-subnav-mobile").css("display") == "none") {
            $(".js-subnav-mobile").slideDown();
            $(".js-show-subnavigation-mobile").addClass("rotate");
        } else {
            $(".js-subnav-mobile").slideUp();
            $(".js-show-subnavigation-mobile").removeClass("rotate");
        }
    },
    showSearch: function (evt) {
        if (searchIsAnimating == false) {
            $(".js-searchoverlay").hide();
            $(".js-searchinput").addClass("show");
            $(".js-searchform").addClass("show");
            $(".js-searchinput").focus();
            $(".js-searchinput")
                .closest(".o-list-inline")
                .addClass("o-list-inline--nohover");
            $(".js-searchform")
                .find("button")
                .addClass("c-topnav__search__submit--black");
            $(".js-searchlabel").hide();

            setTimeout(function () {
                if (searchIsAnimating == false) {
                    $(document).on("click", function (evt) {
                        var target = $(evt.target);

                        if (
                            (target.closest(".js-search"),
                            target.closest(".js-search").length == 0)
                        ) {
                            $(".js-searchoverlay").show();
                            $(".js-searchinput").removeClass("show");
                            $(".js-searchform")
                                .find("button")
                                .removeClass("c-topnav__search__submit--black");

                            setTimeout(function () {
                                $(".js-searchlabel").show();
                                $(".js-searchform").removeClass("show");
                                $(".js-searchinput")
                                    .closest(".o-list-inline")
                                    .removeClass("o-list-inline--nohover");
                            }, 500);

                            $(document).unbind("click");
                        }
                    });
                    searchIsAnimating = false;
                }
            }, 10);
        }
    },
    submitSearch: function (evt) {
        evt.preventDefault();

        var searchinput = $(".js-searchinput");
        var form = $(".js-searchform");

        $(".js-searchoverlay").hide();
        $(".js-searchinput").addClass("show");
        $(".js-searchform").addClass("show");
        $(".js-searchinput")
            .closest(".o-list-inline")
            .addClass("o-list-inline--nohover");
        $(".js-searchform")
            .find("button")
            .addClass("c-topnav__search__submit--black");
        $(".js-searchlabel").hide();

        if (searchinput.val().length == 0 && searchIsAnimating == false) {
            //$(document).one('click',function(){
            searchIsAnimating = true;
            $(".js-searchoverlay").show();
            $(".js-searchinput").removeClass("show");
            $(".js-searchform")
                .find("button")
                .removeClass("c-topnav__search__submit--black");

            setTimeout(function () {
                $(".js-searchlabel").show();
                $(".js-searchform").removeClass("show");
                $(".js-searchinput")
                    .closest(".o-list-inline")
                    .removeClass("o-list-inline--nohover");
                searchIsAnimating = false;
            }, 500);
            //});
        } else {
            var action = form.data("action") + searchinput.val();
            document.location.href = action;
        }

        return false;
    },
    mobileMenuToggle: function (evt) {
        evt.preventDefault();
        $(".js-mobile-menu")
            .find(".c-topnav__icon")
            .last()
            .removeClass("u-hidden");

        if ($(".c-mobilenav").css("display") == "none") {
            $(".js-mobile-menu")
                .find(".c-topnav__icon")
                .first()
                .hide();
            $(".js-mobile-menu")
                .find(".c-topnav__icon")
                .last()
                .show();
        } else {
            $(".js-mobile-menu")
                .find(".c-topnav__icon")
                .first()
                .show();
            $(".js-mobile-menu")
                .find(".c-topnav__icon")
                .last()
                .hide();
        }
    },
    goToSvenModule: function (evt) {
        //get id clicked module
        var item = $(evt.currentTarget);
        var href = item.attr("href");
        var type = item.data("type");

        //ajax count click on navigation
        app.countClick.ajax(type);

        if (href.indexOf("/") == -1) {
            evt.preventDefault();
            var index = $(href).index() / 2;

            //scroll to module
            $("html, body")
                .stop()
                .animate(
                    {
                        scrollTop: $(href).offset().top - 33
                    },
                    100 * index,
                    "swing"
                );

            //hide menu when visible
            if ($(".c-mobilenav").css("display") != "none") {
                $(".js-mobile-menu").trigger("click");
            }
        }
    },
    showAddressList: function () {
        $('.js-nav-address-list').show();
    },
    hideAddressList: function () {
        $('.js-nav-address-list').hide();
    },
    highlightSplashItem: function () {
        $('.js-splash-item').addClass('c-splash__item__low-opacity');
        $(this).removeClass('c-splash__item__low-opacity');
    },
    unHighlightSplashItem: function () {
        $('.js-splash-item').removeClass('c-splash__item__low-opacity');
    }
};

app.hash = {
    init: function () {
        //find-notary-top-btn
        var hash = window.location.hash.slice(1);
        if (hash && (hash === "adresboek" || hash === "annuaire")) {
            $("a#find-notary-top-btn").trigger("click");
        }
    }
};

app.subnav = {
    init: function () {
        $(".js-subsubnav").on("mouseenter mouseleave", app.subnav.hover);
    },
    hover: function () {
        var bgColor =
            "u-bg-" + $(this).data("bgcolor") + " u-color-white is-hovered";

        if (
            $(this)
                .prev()
                .hasClass("is-hovered")
        ) {
            if (
                $(this)
                    .prev()
                    .data("slug") !=
                $(this)
                    .prev()
                    .data("actual")
            ) {
                $(this)
                    .prev()
                    .removeClass(bgColor);
            }
        } else {
            $(this)
                .prev()
                .addClass(bgColor);
        }
    }
};

app.fednotlink = {
    init: function () {
        $(".js-fednotlink").on("click", app.fednotlink.clicked);
    },
    clicked: function (evt) {
        var button = $(evt.currentTarget);
        var type = button.data("type");
        app.countClick.ajax(type);
    }
};

app.ticker = {
    init: function () {
        //if ticker does not exist, don't execute bellow
        if ($(".js-ticker").length == 0) {
            return false;
        }

        //check if ticker dots should be visible
        app.ticker.showhidedots();
        $(window).resize(function () {
            app.ticker.showhidedots();
        });

        //events
        $(".js-ticker").on("mouseenter", app.ticker.mouseenter);
        $(".js-ticker").on("mouseleave", app.ticker.mouseleave);
        $(".js-ticker a").on("click", function (evt) {
            app.countClick.ajax("ticker");
        });
    },
    showhidedots: function () {
        var text = $(".js-ticker").find(".c-ticker__item");
        var wrapper = $(".js-ticker").find(".c-ticker__wrapper");
        var dots = $(".js-ticker").find(".c-ticker__dots");

        if (text.width() > wrapper.width()) {
            dots.removeClass("u-hidden");
        } else {
            dots.addClass("u-hidden");
        }
    },
    mouseenter: function () {
        var text = $(".js-ticker").find(".c-ticker__item");
        var wrapper = $(".js-ticker").find(".c-ticker__wrapper");
        var dots = $(".js-ticker").find(".c-ticker__dots");

        //calculate overflow width
        var widthText = text.width();
        var widthTicker = wrapper.width();
        var animateWidth = widthText - widthTicker;

        dots.hide();

        //if overflow --> show animation
        if (animateWidth > 0) {
            //per 70 pixels, add 1 second to the animation
            var animationduration = Math.round(animateWidth / 70);

            text.removeClass("no-animate");
            text.css("transition-duration", animationduration + "s");
            text.css("left", -animateWidth + "px");
        }
    },
    mouseleave: function () {
        var dots = $(".js-ticker").find(".c-ticker__dots");
        var text = $(".js-ticker").find(".c-ticker__item");

        dots.show();

        //reset position
        text.addClass("no-animate");
        text.css("left", 0);
    }
};

app.objectfit = {
    init: function (setQuality) {
        if (!Modernizr.objectfit) {
            $(".o-object-fit").addClass("o-object-fit__fallback");

            $(".o-object-fit__fallback").each(function (i, object) {
                object = $(object);

                if (object.find("video").length > 0) {
                    //video
                    object.addClass("o-object-fit__fallback__video");

                    app.objectFit.resize(object.find("video"));
                    $(window).resize(function () {
                        app.objectFit.resize(object.find("video"));
                    });
                } else {
                    //img
                    object.find("img").hide();
                    object.addClass("o-object-fit__fallback__image");
                    object.css(
                        "backgroundImage",
                        'url("' + object.find("img").attr("src") + '")'
                    );
                }
            });
        }
    },
    resize: function (video) {
        if (video[0]) {
            var videoWidth = video[0].videoWidth;

            if (!videoWidth) {
                video[0].addEventListener(
                    "loadedmetadata",
                    function (e) {
                        app.objectFit.position(video);
                    },
                    false
                );
            } else {
                app.objectFit.position(video);
            }
        }
    },
    position: function (video) {
        var videoWidth = 1920;
        var videoHeight = 1080;
        //var videoQuality = video.find('source').data('quality');
        var parent = video.parent();

        /*if(videoQuality == 1280){
            videoWidth = 1280;
            videoHeight = 720;
        }
        else if(videoQuality == 960){
        videoWidth = 960;
        videoHeight = 540;
    }
    else if(videoQuality == 640){
    videoWidth = 640;
    videoHeight = 360;
    }*/

        //percentage berekenen van verhouding van breedte movie tov de breedte van de scherm div
        var perc = parent.width() / videoWidth;
        video.css("width", videoWidth * perc);
        video.css("height", videoHeight * perc);

        //als de video minder hoog is als het scherm dan percentage berekenen tov de hoogte van de scherm div
        if (video.height() < parent.height()) {
            var perc = parent.height() / videoHeight;
            video.css("width", videoWidth * perc);
            video.css("height", videoHeight * perc);
        }

        //video centreren
        video.css("left", (parent.width() * 0.5 - video.width() * 0.5) / 2);
        video.css("top", (parent.height() * 0.5 - video.height() * 0.5) / 2);
    }
};

app.tabpannel = {
    init: function () {
        var tabpannelNavigation = $(".js-tabpannel-navigation");
        var tabpannelNavigationExternal = $(".js-tabpannel-navigation-external");
        tabpannelNavigation.on("click", app.tabpannel.clickOnNavigation);
        tabpannelNavigationExternal.on(
            "click",
            app.tabpannel.clickOnExternalNavigation
        );

        //check if maxresdefault gives a result else use lower res image
        $('.youtube-thumb').each(function(ix, it){
            if($(it)[0].naturalHeight <= 90 )
            {
                var path = $(it).attr('src');
                var altpath = path.replace('maxresdefault.jpg','0.jpg');

                $(it).attr('src', altpath);
            }
        });

        // var tabpannelMore = $(".js-tabpannel-more");
        // tabpannelMore.on("click", app.tabpannel.clickOnMore);
    },
    clickOnNavigation: function (evt) {
        var tabpannelNavigation = $(evt.currentTarget);

        console.log('click read');
        var tabpannel = tabpannelNavigation.closest(".js-tabpannel");
        var type = tabpannel.data("type");

        if (type !== undefined) {
            app.countClick.ajax(type);
        }

        //main tabpannel elements
        var tabpannelBody = tabpannel.find(".js-tabpannel-content");
        var tabpannelYoutube = document.querySelectorAll(".js-tabpannel-youtube");
        var tabpannelVideo = tabpannel.find(".js-tabpannel-video");

        // parking & route button:
        var parkingRouteOffices = $(".js-parking-route-office");

        //remove active state of navigation and body
        tabpannel.find(".active").removeClass("active");

        //clicked tabpannel elements
        var navigation = $(evt.currentTarget);
        var index = parseInt(navigation.data("index"));

        var hoursHolidays = $("[data-hours-holiday-id]");

        if (hoursHolidays.length > 0) {
            app.tabpannel.checkHoursAndHolidays(hoursHolidays, index);
        }

        var body = tabpannelBody.eq(index);
        var bodyMobile = navigation.parent().find(".js-tabpannel-content-mobile");

        //if body is visible, prevent link for opening. if not, go to link
        if (tabpannelBody.parent().css("display") != "none") {
            evt.preventDefault();
        }

        //show current tabpannel content
        navigation.addClass("active");
        body.addClass("active");
        bodyMobile.addClass("active");

        // If there is parking or route activate the button
        for (var i = 0; i < parkingRouteOffices.length; i++) {
            $(parkingRouteOffices[i]).data("index") === index
                ? $(parkingRouteOffices[i]).addClass("active")
                : $(parkingRouteOffices[i]).removeClass("active");
        }

        // Click On Address Header or Footer, will also change the Footer or Header status:
        var theTwin;
        $(navigation).hasClass("js-address-navigator")
            ? (theTwin = $($('.c-address__nav-item[data-index="' + index + '"]')[0]))
            : (theTwin = $($('.c-address__nav-item[data-index="' + index + '"]')[1]));
        !theTwin.hasClass("active") && theTwin.click();

        if (app.helpers.viewport().width < 768 && bodyMobile.length > 0) {
            //scroll to position
            $("html, body").animate(
                {
                    scrollTop: navigation.offset().top - $(".js-headroom").outerHeight()
                },
                500
            );
        }

        //reset each youtube in tabpannel
        if (tabpannelYoutube.length > 0) {
            Array.prototype.forEach.call(tabpannelYoutube, function (video, i) {
                video.contentWindow.postMessage(
                    '{"event":"command","func":"pauseVideo","args":""}',
                    "*"
                );
            });
        }

        //reset each video in tabpannel
        if (tabpannelVideo.length > 0) {
            tabpannelVideo.each(function () {
                $(this)[0].pause();
            });
        }

        // // trigger contact nav:
        // if (tabpannelNavigation.hasClass('js-header')) {
        //     console.log('test');
        //     $('.js-tabpannel-navigation.js-non-header:nth-child('+ tabpannelNavigation.index() +')').trigger('click');
        // } else {
        //     $('.js-tabpannel-navigation.js-header:nth-child('+ tabpannelNavigation.index() +')').trigger('click');
        //
        // }
    },
    checkHoursAndHolidays: function (
        arrayOfHoursAndHolidaysPerOffice,
        indexOfSelectedOffice
    ) {
        // console.log("the function", arrayOfHoursAndHolidaysPerOffice);
        for (var i = 0; i < arrayOfHoursAndHolidaysPerOffice.length; i++) {
            var item = $(arrayOfHoursAndHolidaysPerOffice[i]);
            // console.log("holidays", arrayOfHoursAndHolidaysPerOffice[i]);

            item.hasClass("active") && item.removeClass("active");

            // console.log("id", item.data("hours-holiday-id"));

            item.data("hours-holiday-id") === indexOfSelectedOffice &&
            item.addClass("active");
        }
    },
    clickOnExternalNavigation: function (evt) {
        var button = $(evt.currentTarget);
        var tablpannelid = button.data("tabpannelid");
        var tabpannel = $("#" + tablpannelid);
        var index = button.parent().index();
        var navigationItem = tabpannel.find(".js-tabpannel-navigation").eq(index);

        navigationItem.trigger("click");
    },
    clickOnMore: function (evt) {
        var more = evt.currentTarget;
        var parent = more.parentNode.parentNode;
        var content = parent.querySelector(".o-tabpannel__content__body--max");
        var scrollheight = content.scrollHeight;
        console.log('click more');

        content.style.maxHeight = content.scrollHeight + "px";
        more.style.visibility = "hidden";
        $(evt.currentTarget)
            .parent()
            .parent()
            .find(".o-tabpannel__content__body--max")
            .addClass("show");
    }
};

app.ieflex = {
    init: function () {
        if (!Modernizr.smil) {
            var ieflex = $(".js-ieflex");

            app.ieflex.resize(ieflex);
            $(window).resize(function () {
                app.ieflex.resize(ieflex);
            });
        }
    },
    resize: function (ieflex) {
        ieflex.each(function (i, item) {
            ieflex.css("height", "");
            ieflex.css("height", ieflex.height());

            ieflex.find(".js-ieflex__items").css("height", "");
            ieflex.find(".js-ieflex__items").css("height", ieflex.height());

            if (app.helpers.isIE() == 9) {
                ieflex.css("height", "");
                ieflex.find(".js-ieflex__items").css("height", "");
                ieflex.css("minHeight", "0px");
            }
        });
    }
};

app.swipe = {
    init: function () {
        var swipecontainer = $(".js-swipe-container");

        swipecontainer.each(function (i, item) {
            item = $(item);
            var prevBtn = item.find(".js-swipe-navigation-prev");
            var nextBtn = item.find(".js-swipe-navigation-next");
            var container = item.find(".js-swipe");

            swipecontainer.css("overflow", "hidden");

            prevBtn.on("click", function () {
                app.swipe.swipe(container, prevBtn);
            });

            nextBtn.on("click", function () {
                app.swipe.swipe(container, nextBtn);
            });
        });
    },
    swipe: function (container, navigationitem) {
        var width = 100 * navigationitem.index();

        //set position
        container.css({
            "-webkit-transform": "translate(-" + width + "%,0px)",
            "-ms-transform": "translate(-" + width + "%,0px)",
            transform: "translate(-" + width + "%,0px)"
        });

        $(window).resize(function () {
            if (window.innerWidth < 1024 && window.innerWidth > 767) {
                container.css({
                    "-webkit-transform": "none",
                    "-ms-transform": "none",
                    transform: "none"
                });
            } else {
                if ($(".js-holidays > .js-swipe-navigation-next").hasClass("active")) {
                    container.css({
                        "-webkit-transform": "translate(-100%,0px)",
                        "-ms-transform": "translate(-100%,0px)",
                        transform: "translate(-100%,0px)"
                    });
                }
            }
        });

        //set active
        navigationitem
            .parent()
            .children()
            .removeClass("active");
        navigationitem.addClass("active");
    }
};

app.gallery = {
    init: function () {
        //get each gallery and set prev next buttons and timer
        app.gallery.set();

        //if gallery has height, set height on resize
        app.gallery.resize();
        $(window).resize(app.gallery.resize);
    },
    resize: function () {
        var gallery = $(".js-gallery");

        gallery.each(function (i, gallery) {
            gallery = $(gallery);

            if (gallery.hasClass("js-gallery-height")) {
                var galleryItems = gallery.find(".c-gallery__item");
                var height = 0;
                gallery.css("height", "");

                galleryItems.each(function (i, galleryitem) {
                    galleryitem = $(galleryitem);
                    galleryitem.css("height", "auto");

                    if (
                        galleryitem.actual("outerHeight", {includeMargin: true}) > height
                    ) {
                        height = galleryitem.actual("outerHeight", {includeMargin: true});
                    }
                });

                gallery.css("height", height);
            }
        });
    },
    set: function () {
        var gallery = $(".js-gallery");

        //get each gallery on the page
        gallery.each(function (i, gallery) {
            gallery = $(gallery);
            var galleryItems = gallery.find(".c-gallery__item");
            var galleryWrapper = gallery.find(".c-gallery__wrapper");

            //set wrapper sizes
            var totalItems = galleryItems.length;
            galleryWrapper.css("width", Math.ceil(totalItems * 100) + "%");
            galleryItems.css("width", Math.ceil(100 / totalItems) + "%");
            galleryWrapper.css("opacity", 1);

            //check if there are more than one gallery item to set gallery
            if (galleryItems.length > 1) {
                //add first gallery item as last (this is for resetting position when last item has reached)
                galleryItems
                    .first()
                    .clone()
                    .appendTo(galleryWrapper);
                galleryItems = gallery.find(".c-gallery__item");

                //reset wrapper sizes
                var totalItems = galleryItems.length;
                galleryWrapper.css("width", totalItems * 100 + "%");
                galleryItems.css("width", 100 / totalItems + "%");

                //set each gallery item next to each other
                galleryItems.each(function (i) {
                    $(this).css("left", i * (100 / totalItems) + "%");
                });

                //set basic prev and next buttons
                var activeIndex = gallery.data("active");
                var galleryPrev = gallery.parent().find(".js-gallery-prev");
                var galleryNext = gallery.parent().find(".js-gallery-next");
                var galleryNextNumber = gallery.parent().find(".js-gallery-nextnumber");
                galleryPrev.css("opacity", 0.3);

                //prev
                galleryPrev.on("click", function () {
                    //get data attribute active
                    activeIndex = gallery.data("active");

                    //check if prev is possible
                    if (activeIndex > 0) {
                        //set active as variable and data attribute
                        activeIndex--;
                        gallery.data("active", activeIndex);

                        //animate to active slide
                        var translate = (100 / totalItems) * activeIndex;
                        galleryWrapper.css("transform", "translate(-" + translate + "%,0)");
                    }

                    //check if previous slide exist, if not disable prev
                    if (activeIndex == 0) {
                        galleryPrev.css("opacity", 0.3);
                    }

                    //always show next arrow
                    galleryNext.css("opacity", 1);

                    //clear timer if set and reset timer
                    if (gallery.hasClass("js-timer")) {
                        clearInterval(timerInterval);
                        timerInterval = app.gallery.interval(
                            gallery,
                            galleryWrapper,
                            galleryNext,
                            galleryPrev,
                            galleryItems
                        );
                    }
                });

                //next
                galleryNext.on("click", function () {
                    //get data attribute active
                    activeIndex = gallery.data("active");

                    //check if next is possible
                    if (activeIndex < totalItems - 2) {
                        //set active as variable and data attribute
                        activeIndex++;
                        gallery.data("active", activeIndex);

                        //animate to active slide
                        var translate = (100 / totalItems) * activeIndex;
                        galleryWrapper.css("transform", "translate(-" + translate + "%,0)");
                    }

                    //check if next slide exist, if not disable next
                    if (activeIndex == totalItems - 2) {
                        galleryNext.css("opacity", 0.3);
                    }

                    //always show previous arrow
                    galleryPrev.css("opacity", 1);

                    //clear timer if set and reset timer
                    if (gallery.hasClass("js-timer")) {
                        clearInterval(timerInterval);
                        timerInterval = app.gallery.interval(
                            gallery,
                            galleryWrapper,
                            galleryNext,
                            galleryPrev,
                            galleryItems
                        );
                    }
                });

                //clicked on button with a pagenumber
                galleryNextNumber.on("click", function () {
                    var index = $(this).index();

                    //set active classes
                    galleryNextNumber.removeClass("c-gallery__nextnumber--active");
                    $(this).addClass("c-gallery__nextnumber--active");

                    //set active as variable and data attribute
                    activeIndex = index;
                    gallery.data("active", activeIndex);

                    //animate to active slide
                    var translate = (100 / totalItems) * activeIndex;
                    galleryWrapper.css("transform", "translate(-" + translate + "%,0)");
                });

                //timer gallery
                var timerInterval;
                if (gallery.hasClass("js-timer")) {
                    timerInterval = app.gallery.interval(
                        gallery,
                        galleryWrapper,
                        galleryNext,
                        galleryPrev,
                        galleryItems
                    );
                }
            }
        });
    },
    interval: function (
        gallery,
        galleryWrapper,
        galleryNext,
        galleryPrev,
        galleryItems
    ) {
        var activeIndex = gallery.data("active");
        var totalItems = galleryItems.length;
        return setInterval(function () {
            if (activeIndex < totalItems - 1) {
                activeIndex++;
                gallery.data("active", activeIndex);
                var translate = (100 / totalItems) * activeIndex;
                galleryWrapper.css("transform", "translate(-" + translate + "%,0)");
                galleryPrev.css("opacity", 1);

                if (activeIndex == totalItems - 2) {
                    galleryNext.css("opacity", 0.3);
                }

                if (activeIndex == totalItems - 1) {
                    galleryNext.css("opacity", 1);
                    galleryPrev.css("opacity", 0.3);
                    setTimeout(function () {
                        activeIndex = 0;
                        gallery.data("active", activeIndex);
                        var translate = (100 / totalItems) * activeIndex;
                        galleryWrapper.addClass("noanimate");
                        galleryWrapper.css("transform", "translate(-" + translate + "%,0)");
                        setTimeout(function () {
                            galleryWrapper.removeClass("noanimate");
                        }, 100);
                    }, 500);
                }
            }
        }, gallery.data("gallerytime"));
    }
};

app.modal = {
    init: function () {
        var modalbutton = $(".js-modal-navigation");
        var closebutton = $(".js-modal-close");
        var modal = $(".js-modal");

        modalbutton.each(function (i, button) {
            button = $(button);
            button.on("click", app.modal.show);
        });

        closebutton.each(function (i, button) {
            button = $(button);
            button.on("click", function (evt) {
                button.closest(".js-modal").slideUp();
                setTimeout(function () {
                    button
                        .closest(".js-modal")
                        .find(".js-modal-back")
                        .trigger("click");
                    // console.log('clicked');
                }, 600);

                $(".js-overlay").remove();
                // console.log('close');
            });
        });

        //back button
        $(document).on("click", ".js-modal-back", function (evt) {
            evt.preventDefault();

            var button = $(evt.currentTarget);
            button
                .closest(".js-modal")
                .find(".js-modal-page-1")
                .removeClass("u-hidden")
                .css("display", "none")
                .slideDown();
            button
                .closest(".js-modal")
                .find(".js-modal-page-2")
                .slideUp();

            //modal.trigger('changePage', ['js-modal-page-1']);

            setTimeout(function () {
                button
                    .closest(".js-modal")
                    .find(".js-modal-page-2")
                    .css("display", "block")
                    .addClass("u-hidden");
            }, 500);
        });

        //next button
        $(document).on("click", ".js-modal-next", function (evt) {
            evt.preventDefault();
            var button = $(evt.currentTarget);
            button
                .closest(".js-modal")
                .find(".js-modal-page-2")
                .removeClass("u-hidden")
                .css("display", "none")
                .slideDown();
            button
                .closest(".js-modal")
                .find(".js-modal-page-1")
                .slideUp();

            //modal.trigger('changePage', ['js-modal-page-2']);

            setTimeout(function () {
                button
                    .closest(".js-modal")
                    .find(".js-modal-page-1")
                    .css("display", "block")
                    .addClass("u-hidden");
            }, 500);
        });

        modal.each(function (i, modal) {
            modal = $(modal);

            modal.on("click", function (evt) {
                var target = $(evt.target);
                if (target.hasClass("js-modal")) {
                    target.find(".js-modal-close").trigger("click");
                }
            });
        });
    },
    show: function (evt) {
        // console.log(evt);
        evt.preventDefault();
        var button = $(evt.currentTarget);
        var idmodal = button.data("modal");
        var modal = $("#" + idmodal);

        if (modal.hasClass("js-modal-dynamically")) {
            if (button.hasClass("js-modal-people")) {
                //get data from clicked people
                var dataContent = button.find(".o-grid__item__overlay__title").html();
                var dataImage = button.find(".o-grid__item__visual").attr("src");

                app.countClick.ajax("people");
            }

            //modal content
            var modalContent = modal.find(".js-modal-content");
            var modalImage = modal.find(".js-modal-image");

            //reset content in modal
            modalContent.empty();
            modalContent.removeClass("u-3/4@mobile");
            modalImage.empty();

            //set content in modal
            modalContent.html(dataContent);
            modalContent.find(".u-color-white").removeClass("u-color-white");
            modalContent.find(".u-hidden").removeClass("u-hidden");
            modalContent.find(".u-h4").removeClass("u-h4");

            //if there's an image, set image
            if (dataImage) {
                modalContent.addClass("u-3/4@mobile");
                modalImage.html('<img src="' + dataImage + '"/>');
            }
        }

        if (modal.hasClass("js-modal-address")) {
            modal.show();
            app.modal.appendOverlay();
            // $('<div class="u-overlay js-overlay"></div>').appendTo('body');
            // $('body').html();
        } else {
            modal.slideDown();
        }
    },
    appendOverlay: function (e) {
        $('<div class="u-overlay js-overlay"></div>').appendTo("body");

        $(".js-overlay").on("click", function () {
            // modal.
            $(".js-modal-close").click();
        });

        // if ( $('.js-overlay') ) {
        //     $('.js-overlay').remove();
        //     console.log('close');
        // }
    }
};

app.showhide = {
    init: function () {
        var buttonShowHide = $(".js-showhide-button");
        var buttonShow = $(".js-show-button");
        var block = $(".js-showhide-block");

        //click on showhide button
        buttonShowHide.on("click", app.showhide.showHideBlock);
        buttonShow.on("click", app.showhide.showBlock);
        block.find(".js-showhide-close").on("click", app.showhide.showHideBlock);

        block.hide();
        block.removeClass("u-hidden");

        var hash = window.location.hash.slice(1);
        if (hash && (hash === "calendar")) {

            console.log('click calendar');
            $('#calendar-custom').trigger('click');
            $('#videoconf-popup').hide();
        }
    },
    showHideBlock: function (evt) {
        evt.preventDefault();

        var button = $(evt.currentTarget);
        var parent = button.closest(".js-showhide");
        var block = parent.find(".js-showhide-block");
        var hideBlockOnShow = parent.find(".js-hideonshow");

        console.log('parent',parent);

        //if content block is visible, show the block
        if (block.css("display") == "none") {
            app.showhide.showBlock(evt);

            if (block.hasClass("c-mobilenav")) {
                $(".js-headroom").css({
                    "min-height": "100%",
                    background: "rgba(0,0,0,0.5)"
                });
                $(".c-headroom--wrapper").css("background", "white");
            }
        } else {
            //hide block
            block.slideUp();
            if (block.hasClass("c-mobilenav")) {
                $(".js-headroom").css({"min-height": "", background: ""});
                $(".c-headroom--wrapper").css("background", "");
            }

            //when ther's a hideblock on show, show
            hideBlockOnShow.slideDown();

            //hide animation on close button
            setTimeout(function () {
                block.find(".c-btn__close").addClass("c-btn__close--animatestart");
            }, 500);

            //rotate arrow if there's one
            if (parent.find(".js-showhide-button-rotate").length > 0) {
                parent
                    .find(".js-showhide-button-rotate")
                    .removeClass("js-showhide-button-down");
            }
        }
    },
    showBlock: function (evt) {
        evt.preventDefault();

        var button = $(evt.currentTarget);
        var type = button.data("type");
        var parent = button.closest(".js-showhide");
        var block = parent.find(".js-showhide-block");
        var hideBlockOnShow = parent.find(".js-hideonshow");

        if (type) {
            app.countClick.ajax(type);
        }
        if (type == "calendar") {
            var now = moment()
                .utc()
                .startOf("month")
                .toDate();
            app.calendar.getMonth(now);
        }

        //show block
        block.slideDown();

        //when ther's a hideblock on show, hide
        hideBlockOnShow.slideUp();

        //show animation on close button
        setTimeout(function () {
            block.find(".c-btn__close").removeClass("c-btn__close--animatestart");

            //scroll to position
            $("html, body").animate(
                {
                    scrollTop: block.offset().top
                },
                500
            );
        }, 500);

        //rotate arrow if there's one
        if (parent.find(".js-showhide-button-rotate").length > 0) {
            parent
                .find(".js-showhide-button-rotate")
                .addClass("js-showhide-button-down");
        }
    }
};

app.calendar = {
    init: function () {
        if (typeof arrMonths === "undefined") {
            return false;
        }

        //if calendar does not exist, don't execute bellow
        if ($(".c-calendar").length == 0) {
            return false;
        }

        app.calendar.table = $("#calendar-table");

        //click on prev next month
        $(document).on("click", ".js-calendar-prev", app.calendar.showPrevMonth);
        $(document).on("click", ".js-calendar-next", app.calendar.showNextMonth);

        //click on day
        $(document).on("click", ".js-calendar-day", app.calendar.clickOnDay);

        //click on timeslot
        $(document).on(
            "click",
            ".js-calendar-choose-timeslot",
            app.calendar.chooseTimeslot
        );

        //modal actions
        app.calendar.modalActions();

        //validate form
        app.calendar.form();
    },
    getMonth: function (date) {
        var dateTime = date.getTime();
        var timestamp = Math.floor(dateTime / 1000);

        var activeMonth = parseInt(date.getMonth());
        var activeYear = date.getFullYear();
        //set active month
        $(".js-calendar-active-month").data("month", activeMonth);
        $(".js-calendar-active-month").data("year", activeYear);
        $(".js-calendar-active-month").text(
            arrMonths[activeMonth].monthFull.toUpperCase() + " " + activeYear
        );

        app.calendar.activeMonth = activeMonth + 1;
        app.calendar.activeYear = activeYear;

        var nextDate = new Date(
            app.calendar.activeYear,
            app.calendar.activeMonth,
            1
        );

        $.ajax({
            method: "POST",
            url: "/sven/calendar/month/",
            data: {
                date: timestamp
            }
        }).done(function (html) {
            app.calendar.table.html(html);

            // reinit the modals events
            app.modal.init();
        });
    },
    showPrevMonth: function (evt) {
        evt.preventDefault();

        var button = $(evt.currentTarget);

        if (!button.hasClass("c-calendar--disabled")) {
            //add remove class
            button.addClass("c-calendar--disabled");
            $(".js-calendar-next").removeClass("c-calendar--disabled");

            //make previous month date
            var prevMonth = app.calendar.activeMonth - 1;
            var prevYear = app.calendar.activeYear;

            if (prevMonth < 1) {
                prevMonth = 12;
                prevYear -= 1;
            }

            var prevDate = new Date(prevMonth + "/01/" + prevYear + ' 00:00:00 GMT+0000');

            //get previous month
            app.calendar.getMonth(prevDate);
        }
    },
    showNextMonth: function (evt) {
        evt.preventDefault();

        var button = $(evt.currentTarget);

        if (!button.hasClass("c-calendar--disabled")) {
            //add remove class
            button.addClass("c-calendar--disabled");
            $(".js-calendar-prev").removeClass("c-calendar--disabled");

            //make next month date
            var nextMonth = app.calendar.activeMonth + 1;
            var nextYear = app.calendar.activeYear;

            if (nextMonth > 12) {
                nextMonth = 1;
                nextYear += 1;
            }

            var nextDate = new Date(nextMonth + "/01/" + nextYear + ' 00:00:00 GMT+0000');

            //get previous month
            app.calendar.getMonth(nextDate);
        }
    },

    clickOnDay: function (evt) {
        var day = $(evt.currentTarget);
        app.calendar.fullDay =
            day.find("span").text() +
            " " +
            day
                .closest(".js-calendarmonth")
                .find(".c-calendar__month")
                .text();
        app.calendar.timestamp = day.data("timestamp");
        app.calendar.timeSlot = day.data("timeslot");
        app.calendar.availableHoursAjax = day
            .closest("table")
            .data("availablehours");

        //set day in popup
        $(".js-timeslot-date").text(app.calendar.fullDay);
        $(".js-timeslot-wrapper").empty();

        app.calendar.loadAvailableHours();
    },
    loadAvailableHours: function () {
        $(".js-timeslot-wrapper").html("");

        // Get openinghours for day
        $.ajax({
            method: "POST",
            url: app.calendar.availableHoursAjax,
            data: {
                date: app.calendar.timestamp,
                timeSlot: app.calendar.timeSlot
            }
        }).done(function (response) {
            app.calendar.renderDay(response.availableHours);
        });
    },
    renderDay: function (availableHours) {
        if (_.size(availableHours)) {
            $(".js-timeslot-available").removeClass("u-hidden");
            $(".js-timeslot-unavailable").addClass("u-hidden");

            //loop through timeslots and show them
            _.each(availableHours, function (value, key) {
                var time = key.split(":");

                var data = {
                    timeslot_start: moment({hour: time[0], minute: time[1]}).format(
                        "HH:mm"
                    ),
                    timeslot_end: moment({hour: time[0], minute: time[1]})
                        .add(app.calendar.timeSlot, "minutes")
                        .format("HH:mm"),
                    day: app.calendar.fullDay,
                    timestamp: moment
                        .unix(app.calendar.timestamp)
                        .add({hour: time[0], minute: time[1]})
                        .format("X")
                };

                var source = $("#calendar-template").html();
                var template = Handlebars.compile(source);
                var html = template(data);
                $(".js-timeslot-wrapper").append(html);
            });
        } else {
            $(".js-timeslot-available").addClass("u-hidden");
            $(".js-timeslot-unavailable").removeClass("u-hidden");
        }
    },
    chooseTimeslot: function (evt) {
        $(evt.preventDefault());

        var timeslot = $(evt.currentTarget);
        var dayData = timeslot.data("day");
        var timeslotData = timeslot.data("timeslot");
        var timestampData = timeslot.data("timestamp");

        var ajaxUrl = $(".js-timeslot-wrapper").data("ajax");

        $(".js-timeslot-dateform").text(dayData + " - " + timeslotData);
        $(".js-form-hidden-timeslot").val(timeslotData);
        $(".js-form-hidden-date").val(timestampData);
        $(".js-modal-back").removeClass("u-hidden");
        $(".js-form-message").removeClass("u-hidden");
        $(".js-form-appointment").removeClass("is-submitted");
        $(".js-form-appointment").show();
    },
    modalActions: function () {
        var calendar = $(".c-calendar");

        calendar.on("click", ".js-modal-close", function () {
            calendar.find(".c-overlay").hide();

            // Calendar shown when close...
            if (!calendar.find("form").hasClass("is-submitted")) {
                calendar.find("form").show();
                calendar.find(".js-form-validated").addClass("u-hidden");
            }
        });

        calendar.on("click", ".js-showhide-close", function () {
            setTimeout(function () {
                calendar.find(".c-overlay").show();
            }, 550);
        });

        calendar.on("click", ".js-modal-navigation", function () {
            calendar.find(".c-overlay").show();
        });

        calendar.on("click", ".js-modal-next", function () {
            calendar.find(".js-form-validated").addClass("u-hidden");
        });

        calendar.on("click", ".js-modal-back", function () {
            calendar.find(".js-modal-back").addClass("u-hidden");
        });
    },
    form: function () {
        $.validator.addMethod("email", function (email, element) {
            var filter = new RegExp(
                /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
            );
            return filter.test(email);
        });

        $(".js-form-appointment").validate({
            ignore: [],
            rules: {
                email: {email: true}
            },
            submitHandler: function (evt) {
                var form = $(evt);
                var ajaxUrl = form.data("ajax");

                if (ajaxUrl) {
                    $.ajax({
                        method: "POST",
                        url: ajaxUrl,
                        data: form.serialize()
                    }).done(function (response) {
                        if (response.success) {
                            form
                                .parent()
                                .find(".js-form-message")
                                .addClass("u-hidden");
                            form
                                .parent()
                                .find(".js-form-validated")
                                .removeClass("u-hidden");
                            form.addClass("is-submitted");
                            form.hide();

                            app.calendar.loadAvailableHours();
                        }
                    });
                    return false;
                }
            },
            errorPlacement: function (event, element) {
            }
        });
    }
};

app.immo = {
    limit: 4,
    offset: 0,
    enabled: true,
    init: function () {
        var ajaxbutton = $(".js-ajax-showmore-button");
        ajaxbutton.on("click", app.immo.loadMoreImmo);

        $("#immo")
            .find('a.o-grid__item:not(".js-ajax-showmore-button")')
            .on("click", function (e) {
                e.preventDefault();
                app.countClick.ajax("immo");
                var url = $(this).attr("href");
                var win = window.open(url, "_blank");
                if (win) {
                    //Browser has allowed it to be opened
                    win.focus();
                }
            });

        app.immo.form();
    },
    loadMoreImmo: function (evt) {
        evt.preventDefault();

        if (!app.immo.enabled) return false;

        app.immo.enabled = false;

        var button = $(evt.currentTarget);
        var url = button.data("ajax");

        app.countClick.ajax("immo");

        var offset = $("#immo").find('a.o-grid__item:not(".o-grid__item--nohover")')
            .length;

        $.ajax({
            method: "GET",
            url: _.replace(url, "_offset_", offset)
        }).done(function (response) {
            if (response.success) {
                app.immo.setData(response.immos, button, response.total);
            } else {
                app.immo.setData([], button);
            }
        });

        app.immo.offset++;

        //show loading icon and hide dots
        button.find(".c-dots").addClass("u-hidden");
        button.find(".c-loader").removeClass("u-hidden");
    },
    setData: function (immos, button, total) {
        var html = "";
        var emptyGridItem =
            '<div class="o-grid__item o-grid__item--empty o-grid__item--nohover">&nbsp;</div>';
        var removeLoader = false;
        var currentTotalImmos = $("#immo").find(
            'a.o-grid__item:not(".js-ajax-showmore-button")'
        ).length;
        var renderNum = 3;

        // console.log(immos.length, currentTotalImmos, immos.length);
        if (immos.length == 4 && total == currentTotalImmos + immos.length) {
            renderNum = 4;
            removeLoader = true;
        }
        _.each(immos, function (item, i) {
            if (i < renderNum) {
                html += item;
            }
        });

        if (immos.length > 1) {
            while (immos.length < 4) {
                immos.push(emptyGridItem);
                html += emptyGridItem;
            }
        } else {
            removeLoader = true;
        }

        button.before(html);

        if (
            $("#immo").find('a.o-grid__item:not(".js-ajax-showmore-button")')
                .length >= total
        ) {
            removeLoader = true;
        }

        if (removeLoader) {
            button.remove();
        }

        //show dots agian
        setTimeout(function () {
            button.find(".c-dots").removeClass("u-hidden");
            button.find(".c-loader").addClass("u-hidden");

            /*if(stopLoading && !removeLoader) {
                      button.replaceWith(emptyGridItem);
                  }*/
        }, 500);

        app.immo.enabled = true;
    },
    form: function () {
        var form = $(".js-form");
        var formAction = form.attr("action");
        form.each(function () {
            $(this).validate({
                ignore: [],
                rules: {
                    number: {
                        required: true,
                        number: true
                    }
                },
                submitHandler: function (formEvt) {
                    var form = $(formEvt);

                    var input = $(".js-immo-id", form);

                    var reference = input.val();
                    input.removeClass("error");

                    window.open(formAction + reference,"_self")

                     // formEvt.submit();
                },
                errorPlacement: function (event, element) {
                }
            });
        });
    }
};

app.countClick = {
    ajax: function (type) {
        if (typeof path_count_click !== "undefined") {
            $.ajax({
                type: "POST",
                url: path_count_click,
                dataType: "json",
                data: {
                    type: type
                },
                success: function (result) {
                    if (
                        type == "fednotlink" &&
                        $(".js-fednotlink").attr("href") != "" &&
                        $(".js-fednotlink").attr("href") != "#"
                    ) {
                        window.location = $(".js-fednotlink").attr("href");
                    }
                }
            });
        }
    }
};


app.contact = {
    init: function () {
        $(".js-address-navigator").on("click", function () {
            var id = $(this).data("id");
            app.contact.reinitMap();
            app.contact.centerMarker(id);
        });
    },
    reinitMap: function () {
        setTimeout(function () {
            app.contact.map.invalidateSize();
        }, 400);
    },
    initMap: function () {
        app.contact.markers = [];
        app.contact.leafbounds = [];

        app.contact.map = L.map("map-canvas").setView([50.85045, 4.34878], 15);
        L.tileLayer("/maps/tile/{s}/{z}/{x}/{y}", {
            foo: "bar",
            attribution:
                'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
        }).addTo(app.contact.map);

        _.each(addressess, function (data, key) {
            app.contact.addMarker([data.lat, data.lng], data.icon, data.id);
        });

        if (addressess.length > 0) {
            var center = addressess[0];
            app.contact.map.panTo(new L.LatLng(center.lat, center.lng));
        }
    },
    addMarker: function (latlng, icon, id) {
        var iconmarker = L.icon({
            iconUrl: icon,
            iconSize: [35, 47],
            iconAnchor: [17, 47]
        });
        var marker = L.marker(latlng, {icon: iconmarker}).addTo(app.contact.map);
        marker.position = latlng;

        app.contact.leafbounds.push(latlng);
        app.contact.markers[id] = marker;
    },
    centerMarker: function (id) {
        var marker = app.contact.markers[id];
        if (marker) {
            app.contact.map.panTo(marker.position);
        }
    }
};

app.print = {
    init: function () {
        var printbutton = $(".js-print-button");
        printbutton.on("click", app.print.printContent);
    },
    printContent: function (evt) {
        $(evt.preventDefault);

        //get content for printing
        var button = $(evt.currentTarget);
        var content = button.closest(".js-print").find(".js-print-content");

        //open new window and show print popup with content to print
        var newWin = window.open("", "Print-Window");
        newWin.document.open();
        newWin.document.write(
            '<html><body onload="window.print()">' + content.html() + "</body></html>"
        );
        newWin.document.close();
        setTimeout(function () {
            newWin.close();
        }, 10);
    }
};

app.helpers = {
    init: function () {
        app.helpers.viewport();
        // app.helpers.cookie();
        app.helpers.headroom();
        app.helpers.emailspam();
        app.helpers.fancybox();
        app.helpers.disableHoverOnTouch();
        app.helpers.animateDotsLinkMore();
        app.helpers.showHideTextTv();
    },
    viewport: function () {
        var e = window,
            a = "inner";
        if (!("innerWidth" in window)) {
            a = "client";
            e = document.documentElement || document.body;
        }
        return {width: e[a + "Width"], height: e[a + "Height"]};
    },
    isTouch: function () {
        try {
            document.createEvent("TouchEvent");
            return true;
        } catch (e) {
            return false;
        }
    },
    isIE: function () {
        var myNav = navigator.userAgent.toLowerCase();
        return myNav.indexOf("msie") != -1
            ? parseInt(myNav.split("msie")[1])
            : false;
    },
    emailspam: function () {
        //defuscate spam mailing changes @ to at
        $(".email").defuscate();
        $(".mail").defuscate();
    },
    fancybox: function () {
        //fancybox lightbox popup for enlargen images
        $(".js-fancybox").fancybox({
            helpers: {
                title: {type: "inside"},
                buttons: {}
            }
        });
    },
    disableHoverOnTouch: function () {
        var touch = app.helpers.isTouch();

        if (touch) {
            // remove all :hover stylesheets
            try {
                // prevent exception on browsers not supporting DOM styleSheets properly
                for (var si in document.styleSheets) {
                    var styleSheet = document.styleSheets[si];
                    if (!styleSheet.rules) continue;

                    for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                        if (!styleSheet.rules[ri].selectorText) continue;

                        if (styleSheet.rules[ri].selectorText.match(":hover")) {
                            styleSheet.deleteRule(ri);
                        }
                    }
                }
            } catch (ex) {
            }
        }
    },
    animateDotsLinkMore: function () {
        //hoverstate people module when hovering dots --> show text
        var peopledots = $(".js-hover-people");
        var peopletext = $(".js-hover-people-text");

        peopledots.on("mouseenter", function () {
            peopletext.addClass("u-opacity-onhover-full");
            peopletext.removeClass("u-opacity-onhover-none");
            // peopletext.css('opacity',1);
        });
        peopledots.on("mouseleave", function () {
            // peopletext.css('opacity',0);
            peopletext.addClass("u-opacity-onhover-none");
            peopletext.removeClass("u-opacity-onhover-full");
        });
    },
    showHideTextTv: function () {
        var hoveredBlock = $(".js-hover-showhide");
        var textTarget = $(".js-hover-showhide-text");

        hoveredBlock.on("mouseenter", function () {
            textTarget.toggleClass("u-opacity-onhover-none");
            textTarget.toggleClass("u-opacity-onhover-full");
        });
        hoveredBlock.on("mouseleave", function () {
            textTarget.toggleClass("u-opacity-onhover-none");
            textTarget.toggleClass("u-opacity-onhover-full");
        });
    },
    headroom: function () {
        // grab an element
        // console.log(document.querySelector('.js-headroom') !== null ? : );
        if (document.querySelector(".js-headroom") === null) return;

        var myElement = document.querySelector(".js-headroom");
        // construct an instance of Headroom, passing the element
        var headroom = new Headroom(myElement, {
            classes: {
                // when element is initialised
                initial: "c-headroom",
                // when scrolling up
                pinned: "c-headroom--pinned",
                // when scrolling down
                unpinned: "c-headroom--unpinned",
                // when above offset
                top: "c-headroom--top",
                // when below offset
                notTop: "c-headroom--not-top",
                // when at bottom of scoll area
                bottom: "c-headroom--bottom",
                // when not at bottom of scroll area
                notBottom: "c-headroom--not-bottom"
            }
        });
        // initialise
        headroom.init();
    }
};

app.notarissearcher = {
    init: function () {
        $(".js-modal-address form").on("submit", app.notarissearcher.send);
    },
    send: function (e) {
        e.preventDefault();

        var frontend_search_notaris = $(this).attr("action") + "/";
        var recognized = $(".js-modal-address #bemiddelaars");
        var kaart = $(".js-modal-address #show-on-map");

        var kennis = "";
        var search = $(".js-modal-address #input_search_notaris").val();

        if ($(".js-modal-address form select").val() != "") {
            kennis = "/" + $(".js-modal-address form select").val();
        }

        if (search == "" && $(".js-modal-address #bemiddelaars").is(":checked")) {
            search = "all-mediator";
        }
        //
        // if ( search == '' ) {
        //     return;
        // }

        if (search == "" && !recognized.is(":checked")) {
            $(".js-input-search-notaris-error").show();
            $(".js-input-search-notaris")
                .addClass("c-input--error")
                .removeClass("u-margin-bottom-small");
            $(".js-required-label").addClass("c-label--error");
            return false;
        }

        var action = frontend_search_notaris + search;

        if (recognized.is(":checked") && kaart.is(":checked")) {
            action +=
                recognized.attr("data-checked") + kaart.attr("data-checked") + kennis;
        } else if (!recognized.is(":checked") && !kaart.is(":checked")) {
            action += kennis;
        } else if (recognized.is(":checked") && !kaart.is(":checked")) {
            action += recognized.attr("data-checked") + kennis;
        } else if (!recognized.is(":checked") && kaart.is(":checked")) {
            action += kaart.attr("data-checked") + kennis;
        }

        document.location.href = action;
        return false;
    }
};

app.subscription = {
    init: function () {
        $(".js-submit-subscription").on("click", app.subscription.subscribe);
    },
    subscribe: function () {
        var form = $(".js-newsletter form");
        var email = $(".js-input-email").val();
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        // var name = $(".js-input-name").val();

        if (app.subscription.validate(email, reg)) {
            var token = $(".js-token").val();
            // console.log('valid');

            $.post(
                form.data("action"),
                {email: email, locale: form.data("locale"), token: token},

                function (response) {
                    if (response.success) {
                        $(".js-newsletter").slideUp(1000);

                        $(".js-newsletter-thanks")
                            .html(
                                '<p class="u-padding-vertical-small">' +
                                $(".js-newsletter-thanks").data("msg") +
                                "</p>"
                            )
                            .slideDown(1000);
                    }
                },
                "json"
            );
            return false;
        } else {
            return false;
        }
    },
    validate: function (email, reg) {
        var validMail = !(
            email == "" ||
            email == $(".js-input-email").attr("placeholder") ||
            reg.test(email) == false
        );
        // var validName = !(name == "" || name == $(".js-input-name").attr('placeholder'));

        if (!validMail) {
            // && !validName
            $(".js-email-error").show();
            $(".js-input-email")
                .addClass("c-input--error u-margin-bottom-none")
                .focus();
            $(".js-name-error").show();
            // $(".js-input-name").addClass('c-input--error u-margin-bottom-none');
        } else {
            if (!validMail) {
                $(".js-email-error").show();
                $(".js-input-email")
                    .addClass("c-input--error u-margin-bottom-none")
                    .focus();

                $(".js-name-error").hide();
                // $(".js-input-name").removeClass('c-input--error u-margin-bottom-none');
                // } else if (!validName) {
                //     $(".js-name-error").show();
                //     $(".js-input-name").addClass('c-input--error u-margin-bottom-none').focus();
                //
                //     $(".js-email-error").hide();
                //     $(".js-input-email").removeClass('c-input--error u-margin-bottom-none');
            } else {
                $(".js-name-error").hide();
                // $(".js-input-name").removeClass('c-input--error u-margin-bottom-none');
                $(".js-email-error").hide();
                $(".js-input-email").removeClass("c-input--error u-margin-bottom-none");
            }
        }
        return validMail; // && validName;
    }
};

app.tagsclicked = {
    init: function () {
        $(".js-tags a").on("click", app.tagsclicked.countClicks);
    },
    countClicks: function (e) {
        e.preventDefault();

        var slug = $(this).attr("data-slug");
        var href = $(this).attr("href");
        var tagClicked = $(this).attr("data-tag-clicked");

        $.getJSON(tagClicked + "/" + slug, function (result) {
            window.location.href = href;
        });

        // console.log('tags clicked!');
        return false;
    }
};

app.scrollToGlossary = {
    init: function () {
        if (
            $(".innershow")
                .parent()
                .offset()
        ) {
            $("body, html").scrollTop(
                $(".innershow")
                    .parent()
                    .offset().top - 40
            );
        }
    }
};

app.historyReminderOnCalculate = {
    init: function () {
        if (document.querySelector("[data-type=rekenmodule]") === null) return;

        var rekenmodBtn = document.querySelectorAll("[data-type=rekenmodule]");

        Array.prototype.forEach.call(rekenmodBtn, function (el) {
            el.addEventListener("click", function () {
                localStorage.setItem("theLastUrl", window.location.href);
            });
        });
    }
};

/*app.googlemaps = {
init: function(){
var mapDiv = document.getElementById('js-map');

var mapOptions = {
zoom: 1,
minzoom: 1,
mapTypeControl: true,
zoomControl: true,
scaleControl: true,
streetViewControl: true,
mapTypeId: google.maps.MapTypeId.ROADMAP
}

var map = new google.maps.Map(mapDiv, mapOptions);

//var markers = getMarkers(map);
map.setCenter({ lat: 0, lng: 0 });
}
}*/

app.old = {
    init: function () {
        app.old.faq();
        app.old.glossary();
        app.old.activestate();

        $(window).resize(function () {
            app.old.activestate();
        });
    },
    faq: function () {
        $("a.info-content-faq-question").click(function (evt) {
            evt.preventDefault();

            if (
                $(this)
                    .parent()
                    .hasClass(".info-content-faq-active")
            ) {
                $(this)
                    .parent()
                    .removeClass(".info-content-faq-active");
                $(this)
                    .parent()
                    .find("article")
                    .slideUp();
            } else {
                $(this)
                    .parent()
                    .addClass(".info-content-faq-active");
                $(this)
                    .parent()
                    .find("article")
                    .slideDown();
            }
        });
    },
    glossary: function () {
        $("a.wordlistitem").click(function (evt) {
            evt.preventDefault();

            if (
                $(this)
                    .closest("article")
                    .find("div.inner")
                    .css("display") == "none"
            ) {
                $(this)
                    .closest("article")
                    .find("div.inner")
                    .slideDown();
            } else {
                $(this)
                    .closest("article")
                    .find("div.inner")
                    .slideUp();
            }
        });
    },
    readCookie: function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    createCookie: function (name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            var expires = "; expires=" + date.toGMTString();
        } else expires = "";
        document.cookie = name + "=" + value + expires + "; path=/";
    },
    activestate: function () {
        $(".activestate, .activestate-niv2, .activestate-niv3").each(function () {
            var padding =
                parseInt(
                    $(this)
                        .next()
                        .css("padding-top")
                ) +
                parseInt(
                    $(this)
                        .next()
                        .css("padding-bottom")
                );
            $(this).css(
                "height",
                $(this)
                    .next()
                    .height() + padding
            );
        });

        //nieuws&pers active
        if ($(".hideforsmartphone .c-sidebar-nav ul li").length == 1) {
            $(".c-sidebar-nav ul li").addClass("active");
        }
        if (
            $(".c-sidebar-nav").data("route") == "notaris_frontend_news" ||
            $(".c-sidebar-nav").data("route") == "notaris_frontend_news_detail" ||
            $(".c-sidebar-nav").data("route") == "notaris_frontend_news_order" ||
            $(".c-sidebar-nav").data("route") == "notaris_frontend_news_page_order"
        ) {
            if ($(".hideforsmartphone .c-sidebar-nav ul li.active").length == 0) {
                $(".c-sidebar-nav ul li")
                    .first()
                    .addClass("active");
            }
        }
    },
    anchorClick: function() {
        $('a.js-smooth-anchor[href*=\\#]:not([href$=\\#])').on('click', function (evt) {
            evt.preventDefault();
            app.old.smoothScrollingTo(this.hash);
        });
    },
    smoothScrollingTo: function(target) {
        $('html,body').animate({
            scrollTop: $(target).offset().top}, 500);
    }
};

// Initialize app JS on docready
document.addEventListener("DOMContentLoaded", app.init());



